import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const StreetName = () => {
  const { t, updateAddress, errors, streetNumber, streetName, city } = useAddress()

  return (
    <SDFormControl plainLabel error={getError('streetName', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.street_name')}
        onBlur={streetName =>
          updateAddress({ streetName, label: (streetNumber ?? '') + ' ' + (streetName ?? '') + ' ' + (city ?? '') })
        }
        currentValue={streetName}
      />
    </SDFormControl>
  )
}

export default StreetName
